import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const SELECTOR = '.js-off-canvas';
const MODIFIER = 'off-canvas--open';

function initOffCanvas() {
    const OFF_CANVAS_ELEMENTS = [...document.querySelectorAll(SELECTOR)];
    const MAIN_CANVAS = document.querySelector('.dialog-off-canvas-main-canvas');

    if (OFF_CANVAS_ELEMENTS) {
        OFF_CANVAS_ELEMENTS.forEach((element) => {
            const { id } = element;
            const toggles = [...document.querySelectorAll(`[data-target="#${id}"]`)];
            let isOpen = element.classList.contains(MODIFIER);

            toggles.forEach((toggle) => {
                toggle.addEventListener('click', (e) => {
                    e.preventDefault();
                    toggleClass({ element, toggle, isOpen });
                    isOpen = !isOpen;

                    if (isOpen) {
                        MAIN_CANVAS.classList.add('dialog-off-canvas-main-canvas--off-canvas-open');
                    } else {
                        MAIN_CANVAS.classList.remove('dialog-off-canvas-main-canvas--off-canvas-open');
                    }
                });
            });

            window.addEventListener('keyup', (e) => {
                e.preventDefault();

                if ((e.key === 'Esc' || e.key === 'Escape') && isOpen) {
                    element.classList.remove(MODIFIER);
                    enableBodyScroll(element);
                    element.setAttribute('aria-hidden', isOpen);
                    toggles.map((toggle) => toggle.setAttribute('aria-expanded', !isOpen));
                    isOpen = !isOpen;
                }
            });
        });
    }
}

function toggleClass({ element, toggle, isOpen }) {
    if (!isOpen) {
        element.classList.add(MODIFIER);
        disableBodyScroll(element);
    } else {
        element.classList.remove(MODIFIER);
        enableBodyScroll(element);
    }

    toggle.setAttribute('aria-expanded', !isOpen);
    element.setAttribute('aria-hidden', isOpen);
}

export { initOffCanvas };
